import React from "react";
import {
  ToggleWrapper,
  ToggleSlider,
  ToggleHandle,
} from "./ToggleButton.styles";
import { ToggleButtonProps } from "./ToggleButton.types";

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  checked = false,
  disabled = false,
  onChange,
  size = "default",
}) => {
  return (
    <ToggleWrapper checked={!!checked} disabled={!!disabled} size={size}>
      <ToggleSlider
        checked={!!checked}
        disabled={!!disabled}
        size={size}
        onClick={!disabled ? onChange : undefined}
      >
        <ToggleHandle checked={!!checked} disabled={!!disabled} size={size} />
      </ToggleSlider>
    </ToggleWrapper>
  );
};
